import { generatePath } from 'react-router-dom';

type AodRoute = {
  path: string;
  gen: (...args: any[]) => string;
};

export const aodRoutes: Record<string, AodRoute> = {
  // Main AOD routes
  root: {
    path: '/audit/aod',
    gen: () => '/audit/aod',
  },
  rules: {
    path: '/audit/aod/rules',
    gen: () => '/audit/aod/rules',
  },
  runsPast: {
    path: '/audit/aod/runs/past',
    gen: () => '/audit/aod/runs/past',
  },
  runsScheduled: {
    path: '/audit/aod/runs/scheduled',
    gen: () => '/audit/aod/runs/scheduled',
  },

  // AOD Rules routes
  ruleAdd: {
    path: '/audit/aod/rules/add',
    gen: () => '/audit/aod/rules/add',
  },
  ruleView: {
    path: '/audit/aod/rules/:id',
    gen: (id: string | number) => generatePath('/audit/aod/rules/:id', { id: String(id) }),
  },
  /** Path-based tab URL for rule view (e.g. report-config, export-options, runs). */
  ruleViewTab: {
    path: '/audit/aod/rules/:id/:tab',
    gen: (id: string | number, tab: string) =>
      `${generatePath('/audit/aod/rules/:id', { id: String(id) })}/${tab}`,
  },
  ruleViewWithTab: {
    path: '/audit/aod/rules/:id',
    gen: (id: string | number, tab: string) =>
      `${generatePath('/audit/aod/rules/:id', { id: String(id) })}?tab=${tab}`,
  },
  ruleEdit: {
    path: '/audit/aod/rules/:id/edit',
    gen: (id: string | number) => generatePath('/audit/aod/rules/:id/edit', { id: String(id) }),
  },
  ruleManualRun: {
    path: '/audit/aod/rules/:id/manual-run',
    gen: (id: string | number) =>
      generatePath('/audit/aod/rules/:id/manual-run', { id: String(id) }),
  },

  // AOD Runs routes
  runView: {
    path: '/audit/aod/runs/:id',
    gen: (id: string | number) => generatePath('/audit/aod/runs/:id', { id: String(id) }),
  },
  runsWithRuleFilter: {
    path: '/audit/aod/runs/past',
    gen: (ruleId: string | number) => `/audit/aod/runs/past?ruleId=${ruleId}`,
  },
} as const;
